import { render, staticRenderFns } from "./BurialCreateForm.vue?vue&type=template&id=e818e0ea"
import script from "./BurialCreateForm.vue?vue&type=script&lang=js"
export * from "./BurialCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports